import { AgResourceLanguage } from '../types';

export const subscriptionList: AgResourceLanguage['subscriptionList'] = {
  showCheckboxLabel: 'Nur aktive Abonnements anzeigen',
  emptyState: {
    title: 'Dein erstes Abo abschließen',
    text: `Scheinbar hast du noch kein AG1 bestellt. Das kannst du jetzt ändern und deinem Körper jeden Tag wertvolle Nährstoffe, Bakterienkulturen, Botanicals und weitere Zutaten aus echten Lebensmitteln in nur einem Drink geben.`,
    button: 'Hol dir dein AG1'
  },
  subscriptionCard: {
    titleOrder: 'Nächste Bestellung:',
    titleSubscription: 'Abonnementprodukte:',
    activeLabel: 'Aktive',
    cancelLabel: 'Beendet',
    frequencyTitle: 'Versandfrequenz:',
    frequencyDayText: 'Alle',
    manageSubscriptionButton: 'Abonnement verwalten',
    subscriptionDetailsButton: 'Abo-Details',
    reactivateButton: 'Abo erneuern',
    orderDateLabel: 'Bestelldatum:',
    orderTotalLabel: 'Summe:',
    productsSubtitle: 'Produkte:',
    subscriptionDetailsSubtitle: 'Abonnementdetails'
  },
  cancelList: {
    title: 'Beendete Abonnements',
    description: `Reaktiviere dein Abonnement, um AG1 wie von dir gewünscht zu erhalten. Sobald dein Abo aktiv ist, kannst du deine Voreinstellungen bearbeiten und jedes verfügbare AG1-Produkt kaufen.`
  }
};
